import { useCallback } from 'react';

interface MoveSlideByButtonProps {
    currentSlideIndex: number;
    lastSwipeSlideIndex: number;
    setCurrentSlideIndex: (slideIndex: number) => void;
    itemsToScroll?: number;
}

export const useMoveForward = function ({
    currentSlideIndex,
    lastSwipeSlideIndex,
    setCurrentSlideIndex,
    itemsToScroll = 1,
}: MoveSlideByButtonProps) {
    return useCallback(
        (count: number = itemsToScroll) => {
            setCurrentSlideIndex(Math.min(currentSlideIndex + count, lastSwipeSlideIndex));
        },
        [currentSlideIndex, lastSwipeSlideIndex, itemsToScroll, setCurrentSlideIndex],
    );
};
